define('v3/Common/Services/Backend/surveyBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function SurveyBackend () {
		BackendBase.call(this);
	};

	SurveyBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(SurveyBackend.prototype, {
		getSurvey: function () {
			return this._getJsonApi('Survey/GetSurvey');
		},
		answerQuestion: function (questionId, answer, answerOption, completeSurvey) {
			return this._postApi('Survey/AnswerQuestion',
				{ questionId: questionId, answer: answer, answerOption: answerOption, completeSurvey: completeSurvey });
		}
	});

	return new SurveyBackend();
});

